import React, { useEffect, useCallback } from 'react';
import RModal from 'react-modal';
import PropTypes from 'prop-types';
import { useWindowSize } from '../../utils';

const Modal = ({
  children,
  modalIsOpen,
  onClose,
  contentOverflow = 'auto',
}) => {
  const { isMobileView } = useWindowSize();

  const closeModal = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isMobileView && modalIsOpen) {
      closeModal();
      return;
    }
  }, [isMobileView, modalIsOpen, closeModal]);

  const modalStyle = {
    content: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: 0,
      height: '100%',
      border: 'none',
      borderRadius: 0,
      overflow: contentOverflow, // Use the provided contentOverflow or default to 'auto'
    },
    overlay: {
      zIndex: 999,
    },
  };

  return (
    <RModal isOpen={modalIsOpen} style={modalStyle} onRequestClose={closeModal}>
      {children}
    </RModal>
  );
};

Modal.propTypes = {
  children: PropTypes.element,
  modalIsOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentOverflow: PropTypes.string, // Custom overflow value for the modal content
};

export default Modal;
